(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cavendis-collection-header"]) return;
  try {
    
  const editorialAnimations = new WeakMap();
  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    const summary = event.target.closest('.cl-collection-editorial > summary');
    if (!summary) return;
    const details = summary.parentElement;
    const panel = details.querySelector('.cl-collection-editorial__panel');
    if (!panel || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    event.preventDefault();
    if (editorialAnimations.has(details)) return;
    const opening = !details.open;
    details.open = true;
    panel.style.overflow = 'hidden';
    const height = panel.getBoundingClientRect().height;
    const animation = panel.animate(
      opening ? [{ height: '0px', opacity: 0 }, { height: `${height}px`, opacity: 1 }] : [{ height: `${height}px`, opacity: 1 }, { height: '0px', opacity: 0 }],
      { duration: 300, easing: 'ease-out', fill: 'both' }
    );
    editorialAnimations.set(details, animation);
    try { await animation.finished; } catch {}
    if (!opening) details.open = false;
    animation.cancel();
    panel.style.removeProperty('overflow');
    editorialAnimations.delete(details);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cl-osp-product"]) return;
  try {
    
  function initConfidenceAccordions(root) {
    root.querySelectorAll('[data-clo-product] .clo-acc details').forEach(function (details) {
      if (details.dataset.clConfidenceReady) return;
      var summary = details.querySelector('summary');
      if (!summary) return;
      details.dataset.clConfidenceReady = 'true';
      var animation = null;
      var desiredOpen = details.open;
      var originalOverflow = details.style.overflow;
      summary.addEventListener('click', function (event) {
        if (!details.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          if (animation) {
            animation.onfinish = null;
            animation.cancel();
            animation = null;
            details.style.overflow = originalOverflow;
          }
          return;
        }
        event.preventDefault();
        desiredOpen = animation ? !desiredOpen : !details.open;
        var fromHeight = details.getBoundingClientRect().height;
        if (animation) {
          animation.onfinish = null;
          animation.cancel();
        }
        details.open = true;
        var style = window.getComputedStyle(details);
        var borderHeight = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
        var toHeight = desiredOpen ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height + borderHeight;
        details.style.overflow = 'hidden';
        var currentAnimation = details.animate([
          { height: fromHeight + 'px' },
          { height: toHeight + 'px' }
        ], { duration: 300, easing: 'ease-in-out' });
        animation = currentAnimation;
        currentAnimation.onfinish = function () {
          if (animation !== currentAnimation) return;
          details.open = desiredOpen;
          details.style.overflow = originalOverflow;
          animation = null;
        };
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initConfidenceAccordions(document); });
  } else {
    initConfidenceAccordions(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initConfidenceAccordions(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
